import * as React from "react";
const SvgMenu = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M2 2.66895H14V4.00228H2V2.66895ZM2 7.33561H14V8.66895H2V7.33561ZM2 12.0023H14V13.3356H2V12.0023Z" }));
export default SvgMenu;
